import ReactDOM from 'react-dom/client';
import '@styles/tailwind.css';

type ImportResult = {
  [key: string]: React.ComponentType;
};

type ImportFunction = () => Promise<ImportResult>;

const renderComponent = async (
  id: string,
  importFunction: ImportFunction,
  exportName: string,
) => {
  // Don't load any JS if old experience is active.
  if (document.querySelector('.fti-quote-engine')) {
    return;
  }
  const container = document.getElementById(id);
  if (container) {
    const module = await importFunction();
    const Component = module[exportName];
    ReactDOM.createRoot(container).render(<Component />);
  }
};

// Render the [v2_travel_form] shortcode, if it exists.
renderComponent(
  'travel-insurance-engine-form',
  () => import('@shortcodes/Form/Form'),
  'Form',
);

// Render the [v2_result_table] shortcode, if it exists.
renderComponent(
  'travel-insurance-engine-result',
  () => import('@shortcodes/Result/Result'),
  'Result',
);

// // Render testing the experience on local.
if (import.meta.env.MODE === 'development') {
  renderComponent(
    'travel-insurance-engine-playground',
    () => import('@playground/Playground'),
    'Playground',
  );
}
